import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { VivaPhoneInputComponent } from './viva-phone-input.component';

@NgModule({
  declarations: [VivaPhoneInputComponent],
  imports: [CommonModule, IonicModule, FormsModule, ReactiveFormsModule],
  exports: [VivaPhoneInputComponent],
})
export class VivaPhoneInputModule { }
